import angular from 'angular';

const componentOptions = {
    bindings: {
        show: '<'
    },
    controllerAs: 'alertNotifyController',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-alert-notification.html';
    }]
};


const componentInfo = {
    module: 'ib-alert-notification-module',
    selector: 'ibAlertNotification',
    inject: [],
    required: []
};


export class ibAlertNotification implements ng.IController {
    public showAlert = true;
    constructor () {

    }
    hideMessage = (): void => {
        this.showAlert = false;
    };

}


try {
    const mod = angular.module(componentInfo.module);
    ibAlertNotification.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibAlertNotification })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibAlertNotification.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibAlertNotification })
    );
}